@if (labelEnabled()) {
  <blaze-element-header
    [color]="props?.style?.label?.color?.color1"
    [fontFamily]="props?.style?.titleBlock?.fontFamily"
    [fontSize]="props?.style?.titleBlock?.fontSize"
    [fontStyle]="props?.style?.titleBlock?.fontStyle"
    [fontWeight]="props?.style?.titleBlock?.fontWeight"
    [horizontalAlign]="props?.content?.title?.align"
    [icon]="props?.content?.title?.icon"
    [iconColor]="props?.content?.title?.iconColor?.color1"
    [iconPosition]="props?.content?.title?.iconPosition"
    [iconSize]="props?.style?.titleBlock?.iconSize"
    class="mb-16"
  >
    {{ label() }}
  </blaze-element-header>
}

<div class="pdf-border" [ngStyle]="pdfBorderStyles()">
  <div class="w-full h-full relative">
    @if (!hasOtherPdfViewerInstance) {
      @defer {
        <blaze-pdf-viewer-wrapper
          (pdfLoaded)="onPdfLoaded($event)"
          (pdfLoadingFailed)="onPdfLoadingFailed($event)"
          (pdfLoadingStart)="onPdfLoadingStarts()"
          [enableDownload]="enableDownload()"
          [enablePrint]="enablePrint()"
          [filename]="filename()"
          [pdfSrc]="pdfSrc()"
        />
      } @placeholder {
        <div></div>
      }
    }
    @if (isPdfLoading() || errorMessage()) {
      <div class="pdf-overlay">
        <blaze-element-loading-indicator [isVisible]="isPdfLoading()" />

        @if (errorMessage()) {
          <div class="pdf-info">
            <mat-icon svgIcon="icon_question_16" class="icon-24" />
            <div class="message">
              <div class="message-header">Trouble loading your PDF</div>
              <div>{{ errorMessage() }}</div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
